import {
  IDailyRentOfferForMobileSite,
  EBrandingLevel,
} from '../../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';

enum ECloseButtonClassName {
  SingleWithBranding = 'close-btn_single-offer-with-branding',
  SingleNoBranding = 'close-btn_single-offer-no-branding',
}

export const getCloseButtonExtraClassName = (offer: IDailyRentOfferForMobileSite, isSingleOfferMode: boolean) => {
  if (!offer || !isSingleOfferMode) {
    return undefined;
  }

  const showBrandingBlock = offer.brandingLevel === EBrandingLevel.ThirdLevel || offer.isCianPartner;

  return showBrandingBlock ? ECloseButtonClassName.SingleWithBranding : ECloseButtonClassName.SingleNoBranding;
};
